<template>
  <div class="popover-model">
    <!-- 物流公司 -->
    <a-popover v-model="visible" trigger="click" placement="bottomLeft" v-if="type==1">
      <div slot="content" class="a-popover-select" :style="{width: widthNum+'px'}">
        <div class="popover-title">
          <span>{{ title }}</span>
        </div>
        <a-table :loading="{  spinning: $store.state.tabLoding, indicator:indicator }" :columns="columns" :dataSource="dataSource"
          :pagination="false" :customRow="rowClickLogistics" rowKey="id" :scroll="{ y: 220}" bordered>
          <template slot="serialNum" slot-scope="text, record, index">
            <span v-if="index+1!=dataSource.length">{{  index+1 }}</span>
            <img src="@/assets/image/add_shop_1@2x.png" alt="" style="width:24px" v-else
              @click="btnAddTd(text, record, index)">
          </template>
          <template slot="name" slot-scope="text, record, index">
            <div v-if="!text" class="name-input" @click="btnChangeState(text, record, index)">
              <a-input :placeholder="placeholder" v-model="fromData.name" v-focus
                @pressEnter="blurlogistics(text, record, index)" v-if="record.status==2">
              </a-input>
              <span v-if="record.status==1">{{ text }}</span>
            </div>
            <div v-if="text">
              <span v-if="record.status==0" class="product-input-text">{{ text }}</span>
            </div>
          </template>
          <template slot="operation" slot-scope="text, record, index" v-if="record.name">
            <span style="color: #387CFC;cursor: pointer;" @click="btnDeleteLogistics(text, record, index)"
              v-if="record.companyStoreId!=''&&record.companyStoreId!='0'">删除</span>
            <span style="color: #387CFC; padding:0 10px; cursor: pointer;"
              @click="getlogisticsinfo(text, record, index)">选择</span>
          </template>
        </a-table>
        <div class="botton-box">
        </div>
      </div>
      <slot name="trigger-tag"></slot>
    </a-popover>
    <!-- 更多资源——上传图片 -->
    <a-popover v-model="visible" trigger="click" placement="bottomLeft" v-if="type==2">
      <div slot="content" class="a-popover-add-make" style="min-height: 120px">
        <upload-file @onChangeFile="onChangeFile" :fileList="fileList" :isUpload="isUpload"></upload-file>
      </div>
      <slot name="trigger-tag"></slot>
    </a-popover>
    <!-- 倒入商品方式列表 -->
    <a-popover v-model="visible" trigger="click" placement="bottomLeft" v-if="type==3">
      <div slot="content" class="a-popover-operation">
        <a-row v-for="(item,index) in selectList" :key="index" :class="index==statusIndex?'ant-row-active' :''">
          <span @click="btnSelectGoods(item,index)">{{ item.name }}</span>
        </a-row>
      </div>
      <slot name="trigger-tag"></slot>
    </a-popover>
    <!-- 更多资源——收获地址——日期 -->
    <a-popover v-model="visible" trigger="click" placement="bottomLeft" v-if="type==41 || type==42">
      <div slot="content" class="a-popover-add-make">
        <a-row style="margin: 20px 0 10px 0">
          <a-col>
            <span class="label-title">收货日期</span>
            <a-date-picker v-model="voucherDate" format="YYYY-MM-DD" @change="onChangeDate" />
          </a-col>
        </a-row>
        <a-row style="margin: 20px 0 10px 0" v-if="type==41">
          <a-col>
            <span class="label-title">收货地址</span>
            <a-select style="width: 200px;" v-model="addressName" placeholder="收货地址" @change="selectAddress">
              <a-icon slot="suffixIcon" type="caret-down" style="color: #555555" />
              <a-select-option v-for="(item, index) in addressList" :key="index">{{ item.areaName }}</a-select-option>
            </a-select>
          </a-col>
        </a-row>
        <a-row>
          <upload-file @onChangeFile="onChangeFile" :fileList="fileList"></upload-file>
        </a-row>
      </div>
      <slot name="trigger-tag"></slot>
    </a-popover>
    <!-- 更多资源——收货地址 -->
    <a-popover v-model="visible" trigger="click" placement="bottomLeft" v-if="type==4">
      <div slot="content" class="a-popover-add-make">
        <a-row style="margin: 20px 0 10px 0">
          <a-col>
            <span class="label-title">收货地址</span>
            <a-select v-model="addressName" placeholder="收货地址" @change="selectAddress">
              <a-icon slot="suffixIcon" type="caret-down" style="color: #555555" />
              <a-select-option v-for="(item, index) in addressList" :key="index">{{ item.areaName }}</a-select-option>
            </a-select>
          </a-col>
        </a-row>
        <a-row>
          <upload-file @onChangeFile="onChangeFile" :fileList="fileList"></upload-file>
        </a-row>
      </div>
      <slot name="trigger-tag"></slot>
    </a-popover>
    <!-- 加收费用 -->
    <a-popover v-model="visible" trigger="click" placement="bottomLeft" v-if="type==5">
      <div slot="content" class="a-popover-select-user" style="padding-bottom: 30px;">
        <div class="popover-title">
          <span>选择类别</span>
        </div>
        <a-table :columns="columns" :dataSource="dataSource" :pagination="false" :customRow="rowClick" rowKey="id"
          bordered>
          <template slot="serialNum" slot-scope="text, record, index">
            <span>{{  index+1 }}</span>
          </template>
          <template slot="operation" slot-scope="text, record" v-if="record.name">
            <span style="color: #387CFC; padding:0 10px; cursor: pointer;" @click="btnSelectCategory(record)">选择</span>
          </template>
        </a-table>
      </div>
      <slot name="trigger-tag"></slot>
    </a-popover>
    <!-- 收款账户 -->
    <a-popover v-model="visible" trigger="click" placement="bottomLeft" v-if="type==7">
      <div slot="content" class="a-popover-select-user">
        <div class="popover-title">
          <span>多账户</span>
        </div>
        <a-table :columns="columns" :dataSource="dataSource" :pagination="false" rowKey="id" bordered>
          <template slot="serialNum" slot-scope="text, record, index">
            <span>{{  index+1 }}</span>
          </template>
          <template slot="price" slot-scope="text, record, index" v-if="record.name">
            <a-input-number id="inputNumber" v-focus @blur="record.isPriceShow=false" v-model="record.price"
              @change="btnProductCountMore" v-if="record.isPriceShow" />
            <span class="product-input-text name-input" @click="btnShowInput(text, record, index, 3)"
              v-else>{{ text }}</span>
          </template>
        </a-table>
        <div class="total-money">
          <span style="color:#919191">注意：此金额中不含运费</span>
          <span>小计：<span style="color:#F76F14">{{ nowPaymentAmount }}</span></span>
        </div>
        <div class="botton-box">
          <a-button @click="visible=false">取消</a-button>
          <a-button class="ant-btn-color" @click="btnSelectAccounts">确定</a-button>
        </div>
      </div>
      <slot name="trigger-tag"></slot>
    </a-popover>
    <!-- 请设置费用和金额 -->
    <a-popover v-model="visible" trigger="click" placement="bottomLeft" v-if="type==8">
      <div slot="content" class="a-popover-select-cost">
        <div class="popover-title">
          <span>请设置费用和金额</span>
        </div>
        <a-table :columns="columns" :dataSource="dataSource" :pagination="false" rowKey="id" bordered>
          <template slot="serialNum" slot-scope="text, record, index">
            <span v-if="index+1!=dataSource.length">{{  index+1 }}</span>
            <img src="@/assets/image/add_shop_1@2x.png" alt="" style="width:24px" v-else
              @click="btnAddTd(text, record, index)">
          </template>
          <template slot="name" slot-scope="text, record, index" v-if="index+1!=dataSource.length">
            <div v-if="!text" @click="btnChangeState(text, record, index)">
              <a-select style="width: 100%;" placeholder="选择收入类别" @change="selectExtraCharge" v-if="record.status==2">
                <a-icon slot="suffixIcon" type="caret-down" style="color: #555555" />
                <a-select-option v-for="(item, index) in extraCharge" :key="index">{{ item.name }}</a-select-option>
              </a-select>
              <span class="name-input" v-if="record.status==1">{{ text }}</span>
            </div>
            <div v-if="text" @click="btnChangeState(text, record, index)">
              <a-select style="width: 100%;" :default-value="text" @change="selectExtraCharge" v-if="record.status==2">
                <a-icon slot="suffixIcon" type="caret-down" style="color: #555555" />
                <a-select-option v-for="(item, index) in extraCharge" :key="index">{{ item.name }}</a-select-option>
              </a-select>
              <span v-if="record.status==0" class="product-input-text">{{ text }}</span>
            </div>
          </template>
          <template slot="price" slot-scope="text, record, index" v-if="record.name">
            <a-input-number id="inputNumber" v-focus @blur="record.isPriceShow=false" v-model="record.price"
              @change="btnProductCount" v-if="record.isPriceShow" />
            <span class="product-input-text name-input" @click="btnShowInput(text, record, index, 3)"
              v-else>{{ text }}</span>
          </template>
          <template slot="operation" slot-scope="text, record, index" v-if="record.name">
            <span style="color: #387CFC;cursor: pointer;" @click="btnDeleteAdded(text, record, index)">删除</span>
          </template>
        </a-table>
        <div class="total-money">
          <span>小计：<span style="color:#F76F14">{{ nowPaymentAmount }}</span></span>
        </div>
        <div class="botton-box">
          <a-button @click="visible=false">取消</a-button>
          <a-button class="ant-btn-color" @click="btnSelectAdded">确定</a-button>
        </div>
      </div>
      <slot name="trigger-tag"></slot>
    </a-popover>
    <!-- 更多资源——图片 -->
    <a-popover v-model="visible" trigger="click" placement="bottomLeft" v-if="type==9">
      <div slot="content" class="a-popover-add-make" style="min-height: 120px">
        <upload-file :isUpload="false" :fileList="fileList"></upload-file>
      </div>
      <slot name="trigger-tag"></slot>
    </a-popover>
  </div>
</template>
<script>
import moment from "moment";
import uploadFile from "@/components/upload/uploadFile.vue";
import {
  getListByStoreId,
  setAddLogistics,
  setDeleteLogistics,
  getCashBankList,
  financeList,
  customerList,
} from "@/utils/api";
export default {
  data() {
    return {
      visible: false,
      title: "",
      columns: [],
      dataSource: [],
      fromData: {
        name: "",
      },
      placeholder: "",
      addressList: [], // 地址列表
      statusIndex: 0,
      pressEnterNum: 0,
      tdIndex: null,
      // priceValue: 0,
      nowPaymentAmount: 0,

      extraCharge: [],

      fileList: [],
      addressName: undefined,
      isLoding: false,
      indicator: '<a-icon type="loading" style="font-size: 24px" spin />',
      voucherDate: undefined,
    };
  },
  components: {
    uploadFile,
  },
  props: {
    widthNum: {
      type: Number,
      default: 416,
    },
    heightNum: {
      type: Number,
      default: 320,
    },
    type: {
      type: Number,
      default: 1,
    },
    StoreIdOrType: {
      type: Number,
      default: 1,
    },
    selectList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    attachmentResourceList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    otherExpensesVOList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    paymentAccountVOList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    contactCustomerId: {
      type: String,
      default: "",
    },
    contactCustomerAddressId: {
      type: String,
      default: "",
    },
    receiveDate: {
      type: String,
      default: "",
    },
    receiverAddress: {
      type: String,
      default: "",
    },
    isUpload: {
      type: Boolean,
      default: true,
    },
  },
  mounted() {
    this.init();
    if (this.type == 1) {
      this.title = "物流公司设置";
      this.placeholder = "请输入物流公司名称";
      this.columns = [
        {
          title: "序号",
          dataIndex: "serialNum",
          width: 80,
          align: "center",
          scopedSlots: { customRender: "serialNum" },
        },
        {
          title: "物流公司",
          dataIndex: "name",
          width: 200,
          scopedSlots: { customRender: "name" },
        },
        {
          title: "操作",
          dataIndex: "operation",
          scopedSlots: { customRender: "operation" },
        },
      ];
      this.dataSource = [];
      this.getListByStoreId();
    } else if (this.type == 5) {
      this.columns = [
        {
          title: "序号",
          dataIndex: "serialNum",
          width: 80,
          align: "center",
          scopedSlots: { customRender: "serialNum" },
        },
        {
          title: "类别名称",
          dataIndex: "name",
        },
        {
          title: "操作",
          dataIndex: "operation",
          scopedSlots: { customRender: "operation" },
        },
      ];
      this.dataSource = [];
      this.getCashBankList();
    } else if (this.type == 3) {
      this.statusIndex = 0;
    } else if (this.type == 41 || this.type == 42) {
      this.getAddress();
    } else if (this.type == 4) {
      this.getAddress();
    } else if (this.type == 7) {
      this.columns = [
        {
          title: "序号",
          dataIndex: "serialNum",
          width: 80,
          align: "center",
          scopedSlots: { customRender: "serialNum" },
        },
        {
          title: "类别编号",
          dataIndex: "code",
        },
        {
          title: "类别名称",
          dataIndex: "name",
        },
        {
          title: "金额",
          width: 100,
          dataIndex: "price",
          scopedSlots: { customRender: "price" },
        },
      ];
      this.dataSource = [];
      this.getCashBankList();
    } else if (this.type == 8) {
      this.columns = [
        {
          title: "序号",
          dataIndex: "serialNum",
          width: 80,
          align: "center",
          scopedSlots: { customRender: "serialNum" },
        },
        {
          title: "费用名称",
          dataIndex: "name",
          scopedSlots: { customRender: "name" },
        },
        {
          title: "金额",
          width: 100,
          dataIndex: "price",
          scopedSlots: { customRender: "price" },
        },
        {
          title: "操作",
          dataIndex: "operation",
          scopedSlots: { customRender: "operation" },
        },
      ];
      this.dataSource = [];
      this.getFinanceList();
    }
  },
  methods: {
    show() {
      this.visible = true;
      this.statusIndex = 0;
    },
    init() {
      document.addEventListener("keydown", (e) => {
        if (e.keyCode == 38) {
          if (this.statusIndex >= 1) {
            this.statusIndex -= 1;
            event.preventDefault();
          }
        } else if (e.keyCode == 40) {
          if (this.statusIndex < 2) {
            this.statusIndex += 1;
            event.preventDefault();
          }
        } else if (e.keyCode == 13) {
          if (this.visible && this.type == 3 && this.pressEnterNum == 1) {
            this.btnSelectGoods(this.selectList[this.statusIndex]);
          } else {
            this.pressEnterNum = 1;
          }
        }
      });
    },

    // 选择上传附件回调
    onChangeFile(item) {
      this.$emit("onChangeFile", item);
    },

    // 选择日期
    onChangeDate(date, dateString) {
      this.voucherDate = moment(dateString);
      this.$emit("onChangegoodsDate", dateString);
    },

    // 获取地址
    getAddress() {
      if (this.contactCustomerId) {
        let params = new FormData();
        params.append("contactCustomerId", this.contactCustomerId);
        this.addressName = undefined;
        this.$store.state.tabLoding = true;
        customerList(params).then((res) => {
          if (res.code == 200) {
            this.addressList = res.result;
            this.addressList.map((item) => {
              if (item.id == this.contactCustomerAddressId) {
                this.addressName = item.areaName;
              }
            });
            this.$store.state.tabLoding = false;
          } else {
            this.$message.error(res.logMessage);
          }
        });
      }
    },
    // 选择地址
    selectAddress(e) {
      this.$emit("selectAddress", this.addressList[e]);
    },

    // 选择导入商品方式
    btnSelectGoods(item, index) {
      this.visible = false;
      this.statusIndex = index;
      this.$emit("btnSelectGoods", item);
    },

    // 改变状态
    btnChangeState(text, record, index) {
      if (record.status == 0) {
        if (this.tdIndex == index || this.tdIndex == null) {
          this.fromData.name = text;
          this.dataSource[index].status = 2;
          this.tdIndex = index;
        } else {
          this.fromData.name = text;
          this.dataSource[index].status = 2;
          if (this.dataSource[this.tdIndex].name) {
            this.dataSource[this.tdIndex].status = 0;
          } else {
            this.dataSource[this.tdIndex].status = 1;
          }
          this.tdIndex = index;
        }
      } else if (record.status == 1) {
        if (this.tdIndex == index || this.tdIndex == null) {
          this.dataSource[index].status = 2;
          this.tdIndex = index;
        } else {
          this.dataSource[index].status = 2;
          if (this.dataSource[this.tdIndex].name) {
            this.dataSource[this.tdIndex].status = 0;
          } else {
            this.dataSource[this.tdIndex].status = 1;
          }
          this.tdIndex = index;
        }
      } else if (record.status == 2) {
      }
    },
    // 添加行
    btnAddTd(text, record, index) {
      this.dataSource.push({
        id: "2020" + index,
        status: 1,
        isPriceShow: false,
      });
    },
    // 删除行
    btnDelTd(text, record, index) {
      this.dataSource.splice(index, 1);
    },

    // 获取加收费用类型列表
    getFinanceList() {
      let params = new FormData();
      params.append(
        "companyStoreId",
        this.$store.state.userInfo.companyStoreId
      );
      params.append("type", this.StoreIdOrType);
      this.$store.state.tabLoding = true;
      financeList(params).then((res) => {
        if (res.code == 200) {
          this.extraCharge = res.result;
          this.$store.state.tabLoding = false;
        } else {
          this.$message.error(res.logMessage);
        }
      });
    },

    // 选择加收类目
    selectExtraCharge(e) {
      let isSelect = false;
      this.dataSource.map((item, index) => {
        if (item.name == this.extraCharge[e].name) {
          isSelect = true;
          this.$message.warning(item.name + "已经选择");
        }
      });
      if (isSelect) {
        return;
      } else {
        this.dataSource[this.tdIndex].status = 0;
        this.dataSource[this.tdIndex].name = this.extraCharge[e].name;
        this.dataSource[this.tdIndex].price = 0;
        this.dataSource[
          this.tdIndex
        ].otherIncomeExpenditureCategoryName = this.extraCharge[e].name;
        this.dataSource[
          this.tdIndex
        ].otherIncomeExpenditureCategoryId = this.extraCharge[e].id;
        this.dataSource.splice(this.tdIndex, 1, this.dataSource[this.tdIndex]);
      }
    },

    // 删除加收类目
    btnDeleteAdded(text, record, index) {
      this.dataSource.splice(index, 1);
    },
    // 确认选择
    btnSelectAdded() {
      this.visible = false;
      this.$emit("btnSelectAdded", this.dataSource);
    },
    // 确认选择多账户
    btnSelectAccounts() {
      this.visible = false;
      let paymentAccountVOList = [];
      this.dataSource.map((item) => {
        if (item.price > 0) {
          paymentAccountVOList.push({
            amount: item.price,
            financeAccountId: item.id,
            financeAccountName: item.name,
            id: item.editId,
          });
        }
      });
      this.$emit(
        "btnSelectAccounts",
        paymentAccountVOList,
        this.nowPaymentAmount
      );
    },

    // 获取账目列表
    getCashBankList() {
      let params = new FormData();
      params.append(
        "companyStoreId",
        this.$store.state.userInfo.companyStoreId
      );
      this.$store.state.tabLoding = true;
      getCashBankList(params).then((res) => {
        if (res.code == 200) {
          this.dataSource = res.result;
          if (this.dataSource.length > 0) {
            this.dataSource.map((item) => {
              item.status = 0;
              item.isPriceShow = false;
              item.price = 0;
              delete item.children;
            });
          }
          this.$store.state.tabLoding = false;
        } else {
          this.$message.error(res.logMessage);
        }
      });
    },

    // 获取物流公司列表
    getListByStoreId() {
      let params = new FormData();
      params.append(
        "companyStoreId",
        this.$store.state.userInfo.companyStoreId
      );
      this.$store.state.tabLoding = true;
      getListByStoreId(params).then((res) => {
        if (res.code == 200) {
          this.dataSource = res.result;
          this.dataSource.map((item) => {
            item.status = 0;
          });
          this.dataSource.push({
            status: 1,
          });
          this.$store.state.tabLoding = false;
        } else {
          this.$message.error(res.logMessage);
        }
      });
    },
    // 点击更改为输入框
    btnShowInput(text, record, index, type) {
      if (this.tdIndex == index || this.tdIndex == null) {
        if (type == 3) {
          this.dataSource[index].isPriceShow = true;
        }
        this.dataSource.splice(index, 1, this.dataSource[index]);
        this.tdIndex = index;
      } else {
        if (type == 3) {
          this.dataSource[this.tdIndex].isPriceShow = false;
          this.dataSource[index].isPriceShow = true;
        }
        this.dataSource.splice(index, 1, this.dataSource[index]);
        this.tdIndex = index;
      }
    },
    // 输入购买数量、价格
    btnProductCount(e) {
      this.nowPaymentAmount = 0;
      this.dataSource.map((item) => {
        if (item.otherIncomeExpenditureCategoryName) {
          this.nowPaymentAmount += item.price;
        }
      });
    },
    btnProductCountMore(e) {
      this.nowPaymentAmount = 0;
      this.dataSource.map((item) => {
        this.nowPaymentAmount += item.price;
      });
    },
    // 添加物流公司输入名称失去焦点事件
    blurlogistics(text, record, index) {
      record.status = 1;
      if (this.fromData.name) {
        this.blurSetAddLogistics();
      }
    },
    // 添加物流公司
    blurSetAddLogistics() {
      let params = new FormData();
      params.append("name", this.fromData.name);
      params.append("companyId", this.$store.state.userInfo.companyId);
      params.append(
        "companyStoreId",
        this.$store.state.userInfo.companyStoreId
      );
      let data = {
        name: this.fromData.name,
        companyId: this.$store.state.userInfo.companyId,
        companyStoreId: this.$store.state.userInfo.companyStoreId,
      };
      this.$store.state.tabLoding = true;
      setAddLogistics(JSON.stringify(data), {
        "Content-Type": "application/json",
      }).then((res) => {
        if (res.code == 200) {
          this.getListByStoreId();
        } else {
          this.$message.error(res.logMessage);
        }
        this.$store.state.tabLoding = false;
      });
    },
    // 删除物流公司
    btnDeleteLogistics(text, record, index) {
      let params = new FormData();
      params.append("id", record.id);
      params.append(
        "companyStoreId",
        this.$store.state.userInfo.companyStoreId
      );
      this.$store.state.tabLoding = true;
      setDeleteLogistics(params).then((res) => {
        if (res.code == 200) {
          this.getListByStoreId();
        } else {
          this.$message.error(res.logMessage);
        }
        this.$store.state.tabLoding = false;
      });
    },
    // 物流公司选择回调
    getlogisticsinfo(text, record, index) {
      this.visible = false;
      this.$emit("getlogisticsinfo", record, this.type);
    },
    // 点击整行选择公司回调
    rowClickLogistics(record, index) {
      return {
        on: {
          click: () => {
            if(record.name) {
              this.visible = false;
              this.$emit("getlogisticsinfo", record, this.type);
            }
          },
          dblclick: () => {
            if(record.name) {
              this.visible = false;
              this.$emit("getlogisticsinfo", record, this.type);
            }
          },
        },
      };
    },
    // 双击事件
    rowClick(record, index) {
      return {
        on: {
          dblclick: (event) => {
            this.btnSelectCategory(record);
          },
        },
      };
    },
    // 选择账户回调
    btnSelectCategory(record) {
      this.visible = false;
      this.$emit("btnSelectCategory", record);
    },
  },
  watch: {
    visible() {
      if (!this.visible) {
        this.pressEnterNum = 0;
        this.$emit("closePopover");
      }
      if (this.type == 7) {
        this.dataSource[0].isPriceShow = true;
        setTimeout(function () {
          document.getElementById("inputNumber").focus();
          document.getElementById("inputNumber").select();
        }, 100);
      }
    },
    attachmentResourceList: {
      handler(newValue, oldValue) {
        this.fileList = newValue;
      },
      deep: true,
    },
    otherExpensesVOList() {
      this.nowPaymentAmount = 0;
      this.dataSource = [];
      if (this.otherExpensesVOList.length > 0) {
        this.otherExpensesVOList.map((item) => {
          this.dataSource.push({
            status: 0,
            name: item.otherIncomeExpenditureCategoryName,
            id: item.otherIncomeExpenditureCategoryId,
            price: item.amount,
            otherIncomeExpenditureCategoryName:
              item.otherIncomeExpenditureCategoryName,
            otherIncomeExpenditureCategoryId:
              item.otherIncomeExpenditureCategoryId,
            isPriceShow: false,
            orderId: item.id,
          });
          this.nowPaymentAmount += item.amount;
        });
        this.dataSource.push({
          status: 1,
          isPriceShow: false,
          id: "00001",
        });
      } else {
        this.dataSource.push(
          {
            status: 1,
            id: "0001",
            isPriceShow: false,
          },
          {
            status: 1,
            id: "0002",
            isPriceShow: false,
          }
        );
      }
    },
    paymentAccountVOList() {
      this.nowPaymentAmount = 0;
      if (this.paymentAccountVOList.length > 1) {
        this.dataSource.map((item, index) => {
          this.paymentAccountVOList.map((ite, inde) => {
            if (item.id == ite.financeAccountId) {
              item.price = ite.amount;
              item.editId = ite.id;
              this.dataSource.splice(index, 1, item);
              this.nowPaymentAmount += ite.amount;
            }
          });
        });
      } else {
        this.dataSource.map((item, index) => {
          item.price = 0;
          delete item.editId;
        });
      }
    },
    contactCustomerAddressId() {
      this.getAddress();
    },
    contactCustomerId() {
      this.getAddress();
    },
    receiverAddress() {
      this.addressName = this.receiverAddress;
    },
    receiveDate() {
      if (this.receiveDate) {
        this.voucherDate = moment(this.receiveDate);
      }
    },
  },
};
</script>
<style lang="scss" scope>
.a-popover-select {
  .popover-title {
    height: 40px;
    line-height: 25px;
    text-align: center;
  }
  .botton-box {
    display: flex;
    justify-content: center;
    padding: 15px 0 20px 0;
    .ant-btn {
      width: 80px;
      height: 36px;
      line-height: 34px;
      margin-left: 15px;
    }
  }
  .ant-table-body {
    cursor: default;
    tr {
      td {
        padding: 0 10px !important;
        height: 54px;
      }
      .ant-input {
        border-radius: 0 !important;
      }
      .blank-input {
        width: 100%;
        height: 54px;
      }
      .name-input {
        min-height: 36px;
      }
    }
  }
}
.a-popover-add-make {
  width: 340px;
  padding: 0 8px 20px 8px;
  .ant-row {
    display: flex;
    .ant-col {
      height: 36px;
      display: flex;
      align-items: center;
      .label-title {
        display: inline-block;
        font-size: 14px;
        color: #333333;
        padding-right: 16px;
      }
      .ant-select-selection {
        height: 36px !important;
        border-radius: 2px !important;
      }
      .ant-select-selection__rendered {
        line-height: 36px !important;
      }
      .ant-input {
        width: 52px !important;
        height: 32px !important;
        line-height: 32px !important;
        border-radius: 2px !important;
        margin: 0 8px 0 24px;
      }
      .ant-calendar-picker-input {
        width: 200px !important;
        height: 36px !important;
        margin: 0 !important;
      }
      .ant-calendar-picker {
        width: 200px !important;
      }
      .ant-select {
        width: 200px !important;
      }
    }
  }
  .upload-list {
    margin-top: 12px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-left: 72px;
    .ant-col {
      height: 18px;
      margin: 6px 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .icon-name {
        color: #387bfc;
        .anticon-link {
          margin-right: 12px;
        }
      }
      .anticon-link,
      .anticon-delete {
        font-size: 18px;
      }
    }
  }
}
.a-popover-operation {
  border-radius: 6px !important;
  .ant-row {
    padding-bottom: 10px;
    text-align: center;
  }
  .ant-row-active {
    color: #387bfc;
  }

  .ant-row:hover {
    color: #387bfc;
  }
}
.a-popover-select-user {
  width: 495px;
  .popover-title {
    height: 40px;
    line-height: 25px;
    text-align: center;
  }
  .total-money {
    font-size: 14px;
    padding: 15px 0 5px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .botton-box {
    display: flex;
    justify-content: flex-end;
    padding: 15px 0 20px 0;
    .ant-btn {
      width: 80px;
      height: 36px;
      line-height: 34px;
      margin-left: 15px;
    }
  }
  .ant-table-body {
    cursor: default;
    tr {
      td {
        padding: 0 10px !important;
        height: 54px;
        .ant-input {
          border-radius: 0 !important;
        }
        .blank-input {
          width: 100%;
          height: 54px;
        }
        .ant-input-number {
          width: 100%;
        }
        .name-input {
          display: inline-block;
          width: 120px;
          min-height: 36px;
          line-height: 36px;
          padding: 0 10px;
        }
      }
      td:nth-child(4) {
        padding: 0 !important;
      }
    }
  }
}
.a-popover-rebate {
  width: 376px;
  .popover-title {
    height: 40px;
    line-height: 25px;
    text-align: center;
  }
  .rebate-input {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .ant-input-affix-wrapper {
      margin-bottom: 16px;
    }
    .ant-input-affix-wrapper,
    .border-radius-input {
      width: 296px;
    }
  }
  .rebate-text {
    width: 296px;
    font-size: 14px;
    padding-top: 10px;
  }
  .botton-box {
    display: flex;
    justify-content: center;
    padding: 15px 0 20px 0;
    .ant-btn {
      width: 80px;
      height: 36px;
      line-height: 34px;
      margin-left: 15px;
    }
  }
}
.a-popover-select-cost {
  width: 450px;
  .popover-title {
    height: 40px;
    line-height: 25px;
    text-align: center;
  }
  .total-money {
    font-size: 14px;
    padding: 15px 0 5px 0;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  .botton-box {
    display: flex;
    justify-content: center;
    padding: 15px 0 20px 0;
    .ant-btn {
      width: 80px;
      height: 36px;
      line-height: 34px;
      margin-left: 15px;
    }
  }
  .ant-table-body {
    cursor: default;
    tr {
      td {
        padding: 0 10px !important;
        height: 54px;
        .ant-input {
          border-radius: 0 !important;
        }
        .blank-input {
          width: 100%;
          height: 54px;
        }
        .ant-select-selection {
          border-radius: 0 !important;
        }
        .ant-input-number {
          width: 100%;
        }
        .name-input {
          display: inline-block;
          width: 100%;
          min-height: 36px;
          line-height: 36px;
          padding: 0 10px;
        }
        .product-input-text {
          display: inline-block;
          //   width: 100%;
          margin: 0 10px;
        }
      }
      td:nth-child(2),
      td:nth-child(3) {
        padding: 0 !important;
      }
    }
  }
}
</style>
